import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme.css';

import LoginBar from './components/LoginBar';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Callback from './pages/Callback';
import MyListings from './pages/MyListings';
import EditListing from './pages/EditListing';
import Profile from './pages/Profile';
import RequireAuth from './components/RequireAuth';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <LoginBar />
        <div className="container mt-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/posts/:postId" element={<PostDetail />} />
            <Route
              path="/dashboard"
              element={
                <RequireAuth message="You need to be signed in to create a listing.">
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/my-listings"
              element={
                <RequireAuth>
                  <MyListings />
                </RequireAuth>
              }
            />
            <Route
              path="/posts/:postId/edit"
              element={
                <RequireAuth>
                  <EditListing />
                </RequireAuth>
              }
            />
            <Route
              path="/profile"
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/callback" element={<Callback />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
